export default [
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: {
      title: '服务协议隐私政策',
      keepAlive: true
    }
  }
];
